<template>
  <div>
    <van-nav-bar
      :title="$t('app.capital_fund_details.title')"
      left-arrow
      @click-left="$router.push('/account_details')"
    />
    <van-list v-model="loading" :finished="finished" :loading-text="$t('app.common.loading')" :finished-text="$t('app.common.finished')">
      <div style="padding: 15px;">
        <div v-for="(item, index) in list" :key="index">
          <van-row
            class="rowDesign"
          >
            <van-col span="8" style="text-align: left">
              <p style="margin: 0;">{{ item.type }}</p
              ><p style="padding-top: 12px;margin: 0;">{{
                item.name
              }}</p>
            </van-col>
            <van-col span="5" style="text-align: right;" v-if="item.number < 0">
              <span style="color: green">{{ Number(item.number || 0).toFixed(2) }}</span>
            </van-col>
            <van-col span="5" style="text-align: right;" v-else
              ><span style="color: red">{{ Number(item.number || 0).toFixed(2) }}</span></van-col
            >
            <van-col span="11" style="text-align: right">
              <van-row style="padding-bottom: 1px"
                ><p style="margin: 0;">{{ item.balance }}</p>
                <p style="padding-top: 12px;margin: 0;">{{ $getDeviceTime(item.time)}}</p></van-row
              >
            </van-col>
          </van-row>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: "CapitalFundDetails",
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
    };
  },
  mounted: function () {
    this.getList();
  },
  methods: {
    getList() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "capital_log",
            token: sessionStorage.getItem("token"),
            cid: sessionStorage.getItem("cid"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.list = res.data.data;
            that.loading = false;
            that.finished = true;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(that.$t(res.data.msg));
          }
        })
        .catch(()=>{
            that.loading = false;
            that.finished = true;
        });
    },
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.rowDesign {
  text-align: center;
  line-height: 10px;
  padding-top: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgb(200, 201, 204);
  font-size: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/CapitalFundDetails.vue